import { DoneIcon, HistoryEduIcon, RedoRoundedIcon, UndoRoundedIcon } from "@l2r-front/l2r-icons"
import { STATUS_DELIVERED, STATUS_IN_PROGRESS } from "@l2r-front/l2r-shared-campaign"

export const statusesSettings = {
    [STATUS_IN_PROGRESS]: {
        statusLabel: "containers.campaignSidebar.statusSelector.inProgress",
        icon: HistoryEduIcon,
        order: 2,
        statusTransitions: [
            { status: STATUS_DELIVERED, icon: <RedoRoundedIcon color="action/disabled" /> },
        ],
    },
    [STATUS_DELIVERED]: {
        statusLabel: "containers.campaignSidebar.statusSelector.delivered",
        icon: DoneIcon,
        order: 1,
        statusTransitions: [
            { status: STATUS_IN_PROGRESS, icon: <UndoRoundedIcon color="action/disabled" /> },
        ],
    },
}